
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tin-tuc/[slug]",
      function () {
        return require("private-next-pages/tin-tuc/[slug]/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tin-tuc/[slug]"])
      });
    }
  